const whiteList = ['/login', '/auth-redirect']
export default  whiteList